import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const approverMaintenanceService = {
  getHeaders: async () => {
    const res = await axios.get(`${domain}/api/ApproverMaintenance`, { headers });
    return res.data;
  },
  save: async (payload, id = null) => {
    console.log({approverMaintenanceService: payload})
    if (id) {
      return await axios.put(`${domain}/api/ApproverMaintenance/${id}`, payload, { headers });
    }
    return await axios.post(`${domain}/api/ApproverMaintenance`, payload, { headers });
  }
};

export default approverMaintenanceService;